import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../../store';
import { fetchCalendarProviders } from '../../store/slices/calendarSlice';

export const useCalendar = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { calendarProvider, isLoading, error } = useSelector((state: RootState) => state.calendar);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const resourceId = useSelector((state: RootState) => state.auth.clientResourceId);

  if (!selectedOrganizationId) {
    console.error('No selected organization ID found in the Redux store.');
  }

  const fetchCalendarProviderData = useCallback(() => {
    if (selectedOrganizationId && resourceId) {
      dispatch(
        fetchCalendarProviders({
          organizationId: selectedOrganizationId,
          resourceId: Number(resourceId),
        })
      );
    }
  }, [dispatch, selectedOrganizationId, resourceId]);

  useEffect(() => {
    fetchCalendarProviderData();
  }, [fetchCalendarProviderData]);

  return {
    calendarProvider,
    isLoading,
    error,
    selectedOrganizationId,
    calendarrefetch: fetchCalendarProviderData,
  };
};
